// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"34a561c0","769":"cc50cd88"}[chunkId] + ".chunk.js";
};